export default __webpack_public_path__ + "static/media/shoppinglist@3x.74a7ab82.png";